import { Controller } from '@hotwired/stimulus';

// The "MET WHEN SIGNED" call-out on a goal's row, kept in step with the entry band while the
// therapist works on the report: pick a status or type a target and it appears, or changes;
// clear both and it goes. The server renders the same words on load (progress_reports/goals/_goal),
// this only follows the fields from there.
//
// Mounted on the goal card. The status is the Impulse select's hidden carrier, which is set before
// the select announces `awc-autocomplete:commit` / `awc-autocomplete:clear`; the target is a plain
// number input, so `input` covers it. Both events bubble to the card, which is where the actions
// sit. The words match ProgressReports::Proposals::Proposal#status_label and _goal's pending_words.
//
// Targets:
//   callout  the wrapper on the row (hidden while nothing is proposed)
//   words    the text inside the badge, before " when signed"
const LABELS = { met: 'Met', discontinue: 'Discontinued' };

export default class extends Controller {
  static targets = ['callout', 'words'];

  refresh() {
    if (!this.hasCalloutTarget) return;
    const words = [];
    const status = this.statusValue();
    const target = this.targetValue();
    if (status) words.push(LABELS[status] || status);
    if (target) words.push(`target ${target}%`);
    this.calloutTarget.hidden = words.length === 0;
    if (this.hasWordsTarget) this.wordsTarget.textContent = words.join(', ');
  }

  statusValue() {
    const field = this.element.querySelector('input[data-behavior="hidden-field"][name$="[proposed_status]"]');
    return field ? field.value : '';
  }

  targetValue() {
    const field = this.element.querySelector('input[name$="[proposed_target]"]');
    return field ? field.value.trim() : '';
  }
}
